import { useTranslations } from 'next-intl';

import { useNotification } from './useNotification';

export interface CustomErrorCondition {
    cond: unknown;
    severity?: 'success' | 'error' | 'warning' | 'info';
    message?: string | null;
    fn?: (() => void) | null;
    autoClose?: number;
}

export const useDisplayRequestErrors = () => {
    const t = useTranslations();
    const notification = useNotification();

    const display = (err: { message: string; status?: number; }, customErrors: CustomErrorCondition[] = [], exclude401 = false, exclude403 = false, showFallbackError = true): boolean => {
        if (err.message === 'fetch failed') {
            notification('error', t('service-temporarily-unavailable-please-try-again-later'));
            return true;
        } else if (!exclude401 && err.status === 401) {
            notification('warning', t('your-session-has-expired-please-log-in-again'));
            return true;
        } else if (!exclude403 && err.status === 403 && err.message === 'FORBIDDEN') {
            notification('error', t('you-do-not-have-the-required-rights'));
            return true;
        } else {
            for (let i = 0; i < customErrors.length; i++) {
                const { cond, severity = 'error', message = null, fn = null, autoClose = undefined } = customErrors[i] as CustomErrorCondition;
                if (cond) {
                    if (fn) {
                        fn();
                    }
                    if (message) {
                        notification(severity, message, autoClose);
                    }
                    return true;
                }
            }
            if (showFallbackError) {
                notification('error', t('an-error-occurred'));
            }
            return false;
        }
    };

    return display;
};